import { BaseChartElement } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/chart-component/chart-elements/base';
import {
    ChartElementType,
    IChartElement,
    IChartElementGroup,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-interaction.interface';
import { Chart as G2Chart } from '@tencent/chart/lib/antv/g2';

interface IDataLabelElement extends IChartElement {
    extra: {
        name: string;
        [props: string]: any;
    }
}

export class DataLabel extends BaseChartElement {
    public getElements(chart: G2Chart): Array<IChartElement | IChartElementGroup> {
        const geometries = chart.views.map(view => ({
            viewId: view.id,
            geometries: view.geometries,
        }));

        const labelElementsGroupList: IChartElementGroup[] = [];
        geometries.map(({ geometries, viewId }) => {
            geometries.map((geometriy, geometryIndex) => {
                const geometryElements: IDataLabelElement[] = [];
                geometriy.elements.map((ele, elementIndex) => {
                    if (ele.labelShape.length > 0) {
                        return ele.labelShape.map((labelShape) => {
                            const labelCfg = labelShape?.cfg;
                            if (!labelCfg) return null;

                            const { data } = labelCfg;
                            // cacheCanvasBBox在isInView=false时可能为none，就从子元素获取rect
                            const g2Rect = labelCfg.cacheCanvasBBox || labelCfg.children.find(c => c.cfg?.type === 'text')?.getCanvasBBox?.();
                            const elementRect = {
                                left: g2Rect?.x || 0,
                                top: g2Rect?.y || 0,
                                width: g2Rect?.width || 0,
                                height: g2Rect?.height || 0,
                            };
                            const path = this.convertRectToPath(elementRect);
                            geometryElements.push({
                                extra: data,
                                rect: elementRect,
                                path,
                                type: ChartElementType.DATA_LABEL,
                                id: `${ChartElementType.DATA_LABEL}-${data.id}-${viewId}-${geometryIndex}-${elementIndex}`,
                            });
                        });
                    }
                });

                const groupedElements = this.groupBy(geometryElements, 'extra.seriesId');
                Object.keys(groupedElements).forEach((seriesId, index) => {
                    const groupId = `${ChartElementType.DATA_LABEL}-${viewId}-${geometryIndex}-${seriesId}`;
                    labelElementsGroupList.push({
                        group: groupedElements[seriesId].map(groupElement => ({
                            ...groupElement,
                            groupId,
                        })),
                        type: ChartElementType.DATA_LABEL,
                        id: groupId,
                    });
                });
            });
        });

        return labelElementsGroupList;
    }
}
